import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckupChallengesComponent } from './checkup-challenges.component';

const routes: Routes = [{ path: '', component: CheckupChallengesComponent }];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
